import request, { METHODS } from "src/utils/api-base";

const tenantApis = {
  createTenant: (payload: { page: number; limit: number }) => {
    return request({
      route: "/admin/tenants/create",
      method: METHODS.POST,
      payload,
      auth: true,
      isAdminAuth: true,
    });
  },
  editTenant: (payload: any) => {
    return request({
      route: `/admin/tenants/${payload._id}`,
      method: METHODS.PUT,
      payload,
      auth: true,
      isAdminAuth: true,
    });
  },
  getTenantList: (params: {
    page: number;
    limit: number;
    search?: string;
    status?: string;
  }) => {
    return request({
      route: "/admin/tenants/list",
      method: METHODS.GET,
      params,
      auth: true,
      isAdminAuth: true,
    });
  },
  getTenantDetails: (tenantId: string) => {
    return request({
      route: `/admin/tenants/${tenantId}`,
      method: METHODS.GET,
      auth: true,
      isAdminAuth: true,
    });
  },

  getTenantRoleList: ({
    tenantId,
    isAdminAuth = false,
  }: {
    tenantId?: string;
    isAdminAuth?: boolean;
  }) =>
    request({
      route: `${isAdminAuth ? "/admin" : "/app"}/tenant-roles`,
      method: METHODS.GET,
      params: tenantId ? { tenantId } : undefined,
      auth: true,
      isAdminAuth,
    }),

  createTenantRole: (payload: any) => {
    const { isAdminAuth = false, ...data } = payload || {};
    return request({
      route: `${isAdminAuth ? "/admin" : "/app"}/tenant-roles`,
      method: METHODS.POST,
      payload: data,
      auth: true,
      isAdminAuth,
    });
  },

  editTenantRole: (payload: {
    id: string;
    data: any;
    isAdminAuth?: boolean;
  }) => {
    const { id, data, isAdminAuth = false } = payload || {};
    return request({
      route: `${isAdminAuth ? "/admin" : "/app"}/tenant-roles/${id}`,
      method: METHODS.PUT,
      payload: data,
      auth: true,
      isAdminAuth,
    });
  },

  deleteTenantRole: (payload: { id: string; isAdminAuth?: boolean }) => {
    const { id, isAdminAuth = false } = payload || {};
    return request({
      route: `${isAdminAuth ? "/admin" : "/app"}/tenant-roles/${id}`,
      method: METHODS.DELETE,
      auth: true,
      isAdminAuth,
    });
  },

  extendTenantPlan: ({ id, data }: { id: string; data: any }) =>
    request({
      route: `/admin/tenants/${id}/extend-plan`,
      method: METHODS.POST,
      payload: data,
      auth: true,
      isAdminAuth: true,
    }),
};

export default tenantApis;
